export default "__VITE_ASSET__C7GH8Wzu__"